import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { EncryptService } from './encrypt.service';

@Injectable({
  providedIn: 'root'
})
export class RevokeTokenService {

  constructor(
    private httpClient: HttpClient,
    private encryptService: EncryptService
  ) { }

  revokeToken(): Observable<any> {
    const API_URL = `${environment.keycloakUrl}/realms/${environment.keycloakRealm}`;
    const clientId = environment.keycloakClientId;


    const url = window.location.origin + '/home';
    const loginEndpoint = `${API_URL}/protocol/openid-connect/logout`;
    const body = new URLSearchParams();
    const refreshLogIn = sessionStorage.getItem('refreshLogIn');
    if (refreshLogIn !== null) {
      body.set('refresh_token', refreshLogIn);
    }
    body.set('client_id', clientId);
    body.set('redirect_uri', url);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
    return this.httpClient.post(loginEndpoint, body.toString(), httpOptions);
  }
}
